import { partInfoHelper } from "@/components/mixins";
import CurrencyText from "@/components/Elements/CurrencyText.vue";
import LoadingSpinner        from "@/components/Elements/LoadingSpinner.vue";
import SkeletonLoader from "@/components/Elements/SkeletonLoader.vue";


export default {
  components: {
    CurrencyText,
    LoadingSpinner,
    SkeletonLoader
  },
  props: {
    part: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
  mixins: [partInfoHelper],
  methods: {},
}